// extracted by mini-css-extract-plugin
export default {"MaxMessageInfo":"MaxMessageInfo_MaxMessageInfo__W8+TK"};